import React from 'react';
import { CtaButton } from './CtaButton';
import { RatingProof } from './RatingProof';
import { Waves } from './Waves';
import { heroImage } from '../data/heroImage';
const chips = [{
  label: '6 volumes',
  dot: 'bg-sage'
}, {
  label: '300 pages',
  dot: 'bg-teal'
}, {
  label: '24+ class plans',
  dot: 'bg-peach'
}, {
  label: '17 routines in 8-counts',
  dot: 'bg-sky'
}, {
  label: '5 bonuses',
  dot: 'bg-rose'
}];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'No subscription'];
export function Hero() {
  return <section className="stage-smoke relative w-full overflow-hidden text-white" data-id="element-114" data-mp="xb5r1d2hkpv7">
      <p aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-4 select-none text-center font-poster text-[26vw] uppercase leading-none text-white/[0.07] lg:top-8 lg:text-[270px]" data-id="element-115" data-mp="sa02lrfuzorh">
        Bollywood
      </p>

      <div className="relative mx-auto max-w-6xl px-5 pt-12 sm:pt-16" data-id="element-116" data-mp="382p73hcojln9">
        <div className="grid items-center gap-8 lg:grid-cols-[1fr_1.15fr] lg:gap-6" data-id="element-117" data-mp="384jur3fc5rv1">
          <div data-id="element-118" data-mp="3j9ahvf8c4u67">
            <p className="text-sm font-semibold text-peach" data-id="element-119" data-mp="3j6obvk13emq3">
              Bollywood Class Ready · for Bollywood dance instructors
            </p>
            <h1 className="mt-4 font-display text-[40px] leading-[1.04] sm:text-[58px] md:text-[64px]" data-id="element-120" data-mp="39b4l1c1dye87">
              A full year of Bollywood classes, ready to teach.{' '}
              <span className="text-peach" data-id="element-121" data-mp="30ib0az366mmy">No more blank page on Sunday night.</span>
            </h1>
            <p className="mt-5 max-w-xl text-base text-white/80 sm:text-lg" data-id="element-122" data-mp="358hncui19z33">
              Six volumes of done-for-you classes for kids, beginners, adults
              and recreational groups. Every step and routine written in clear
              8-count blocks, with the cues, the levels and the timing already
              done. Open it, pick a class, teach it.
            </p>
            <div className="mt-6 lg:hidden" data-id="element-123" data-mp="2hljb690y5daz">
              <CtaButton data-id="element-124" data-mp="2ljpch1j0n0oi">Get Bollywood Class Ready</CtaButton>
              <div className="mt-4 flex justify-center" data-id="element-125" data-mp="s21kmih80q35">
                <RatingProof tone="dark" data-id="element-126" data-mp="s3mb9x0ezovq" />
              </div>
            </div>
            <ul className="mt-6 flex flex-wrap gap-2" data-id="element-127" data-mp="na9z4mcx9ajv">
              {chips.map(chip => <li key={chip.label} className="flex items-center gap-2 rounded-full bg-white/10 px-3 py-1.5 text-xs font-semibold text-white/90 ring-1 ring-white/15" data-id="element-128" data-mp="id9v0gzmuhve">
                  <span className={`h-2 w-2 rounded-full ${chip.dot}`} data-id="element-129" data-mp="1b0du65c1o1z9" />
                  {chip.label}
                </li>)}
            </ul>
          </div>

          <img src={heroImage} alt="A Bollywood dance group in jewel-toned costumes, mid-routine on a stage" width={1376} height={768} className="stage-fade -mx-5 w-[calc(100%+2.5rem)] max-w-none object-cover sm:mx-0 sm:w-full" data-id="element-130" data-mp="111y9ak3m1oy7" />
        </div>

        <div className="mt-8 flex flex-col items-center" data-id="element-131" data-mp="3hqkbsklh5wuf">
          <div className="hidden w-full max-w-md lg:block" data-id="element-132" data-mp="1x9kwssxc7gkd">
            <CtaButton data-id="element-133" data-mp="1xb5ped03cpfl">Get Bollywood Class Ready</CtaButton>
          </div>
          <div className="mt-5 hidden lg:block" data-id="element-134" data-mp="21bplrecubp0o">
            <RatingProof tone="dark" data-id="element-135" data-mp="269zi3saawvnv" />
          </div>
          <p className="mt-4 max-w-md text-center text-sm text-white/75" data-id="element-136" data-mp="2697ouo46fa0r">
            Written for Bollywood instructors teaching in studios, gyms,
            schools, community centers and online. 30, 45 or 60-minute
            classes. One payment, yours to keep.
          </p>
          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/65" data-id="element-137" data-mp="2kxubzc01p62j">
            {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-138" data-mp="2p1a9eajxvaga">
                <span className="h-1.5 w-1.5 rounded-full bg-peach" data-id="element-139" data-mp="2tyir6a16dch0" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
      <Waves to="#FFFFFF" className="relative mt-10" data-id="element-140" data-mp="zlaro5298cp1" />
    </section>;
}